import { DefaultButton } from "@fluentui/react";
import { Icon } from "@fluentui/react/lib/Icon";
import { Stack } from "@fluentui/react/lib/Stack";
import { useState } from "react";

import { ApiConfig, ManageSignaturesModal } from "../ManageSignaturesModal";

import { Account } from "@/components/Contracts/contract.interface";
import SignatureTable from "@/components/Contracts/DisplayContractInfo/ContractSignatures/SignatureTable";
import { DefaultCardTitle } from "@/components/Contracts/DisplayContractInfo/styles";
import { Card } from "@/components/Shared/Card";
import {
  IDocumentEletronicSignature,
  ITermDataDraft
} from "@/modules/Terms/interfaces/ITerm.interface";

interface SignatureResendSectionProps {
  businessUnitId: number;
  refetchData: () => Promise<void>;
  apiConfig: ApiConfig;
  account?: Account;
  electronicSignature?: IDocumentEletronicSignature;
  termDataDraft?: ITermDataDraft;
  canUpdateSignatureMethod?: boolean;
  cardProps?: {
    borderRadius?: string;
    padding?: string;
    height?: string;
  };
}

export const SignatureResendSection = ({
  electronicSignature,
  cardProps = {
    borderRadius: "1rem",
    padding: "1rem"
  },
  businessUnitId,
  account,
  refetchData,
  apiConfig,
  termDataDraft,
  canUpdateSignatureMethod = true
}: SignatureResendSectionProps) => {
  const [isManagementModalOpen, setIsManagementModalOpen] = useState(false);

  return (
    <Stack verticalFill>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <DefaultCardTitle>
          <Icon iconName="OpenEnrollment" style={{ marginRight: 10 }} />
          Assinaturas
        </DefaultCardTitle>

        <DefaultButton onClick={() => setIsManagementModalOpen(true)}>
          Gerenciar
        </DefaultButton>
      </Stack>

      <Card {...cardProps}>
        {cardProps.height === "inherit" ? (
          <div style={{ height: "100%" }}>
            <SignatureTable signatures={electronicSignature} />
          </div>
        ) : (
          <SignatureTable signatures={electronicSignature} />
        )}
      </Card>

      <ManageSignaturesModal
        isOpen={isManagementModalOpen}
        onDismiss={() => setIsManagementModalOpen(false)}
        electronicSignature={electronicSignature}
        account={account}
        refetchData={refetchData}
        apiConfig={apiConfig}
        businessUnitId={businessUnitId}
        termDataDraft={termDataDraft}
        canUpdateSignatureMethod={canUpdateSignatureMethod}
      />
    </Stack>
  );
};
